<section class="starter-kit-shared-squidex" [ngClass]="styleClass">
  <div class="topic">
    <h2 class="topic__title">{{ getMessage('TEXT__TITLE') }}</h2>
    <div class="topic__detail">{{ getMessage('TEXT__DETAIL') }}</div>
  </div>
  <div class="book desktop">
    <ng-container *ngFor="let item of starterKitList">
      <div class="book__img" (click)="onChildEvent(item)">
        <picture>
          <source [srcset]="item.bookImageWebP" type="image/Webp" />
          <img [src]="item.bookImage" loading="lazy" class="book__img--layout" [alt]="item.bookTitle | translate" />
        </picture>
      </div>
    </ng-container>
  </div>
  <swiper-container class="swiper mobile" appSwiper [config]="config" init="false">
    <ng-container *ngFor="let item of starterKitList">
      <swiper-slide class="swiper-slide">
        <div class="book-mobile">
          <div class="book-mobile__img" (click)="onChildEvent(item)">
            <picture>
              <source [srcset]="item.bookImageWebP" type="image/Webp" />
              <img
                [src]="item.bookImage"
                loading="lazy"
                width="100%"
                class="book-mobile__img--layout"
                [alt]="item.bookTitle"
              />
            </picture>
          </div>
        </div>
      </swiper-slide>
    </ng-container>
  </swiper-container>

  <div *ngIf="bookSelected" id="scrollToElement" class="box" [ngClass]="{ 'box--current': bookSelected }">
    <div class="box__left">
      <div class="box__left--title"> {{ bookSelected.bookTitle | translate }}</div>
      <div class="box__left--detail"> {{ bookSelected.bookDetail | translate }}</div>

      <div class="box__left--input" *ngIf="bookSelected.bookPdfLinkFree">
        <form [formGroup]="myForm" (ngSubmit)="save(bookSelected.bookPdfLinkFree)">
          <button type="submit" class="input-btn">{{ getMessage('TEXT__DOWNLOAD') }}</button>
        </form>
      </div>

      <div class="box__left--input" *ngIf="bookSelected.bookPdfLink">
        <span>{{ getMessage('TEXT__CUSTOMERID') }}</span>
        <form [formGroup]="myForm" (ngSubmit)="save(bookSelected.bookPdfLink)">
          <input
            type="text"
            formControlName="supportCode"
            placeholder="{{ getMessage('TEXT__SUPPORTCODE') }}"
            maxlength="7"
          /><br />
          <button type="submit" class="input-btn" [disabled]="!myForm.valid">{{ getMessage('TEXT__DOWNLOAD') }}</button>
        </form>
        <div class="input-text">
          <span>{{ getMessage('TEXT__FREESIGNUP--1') }}</span>
          <span>
            <a
              class="input-text__hover input-text__flow"
              href="https://auth.flowaccount.com/th/Account/Register"
              target="_blank"
              >{{ getMessage('TEXT__FREESIGNUP--2') }}</a
            ></span
          >
          <span>{{ getMessage('TEXT__FREESIGNUP--3') }}</span>
        </div>
      </div>
    </div>

    <div class="box__right">
      <picture>
        <source [srcset]="bookSelected.bookImageWebP" type="image/Webp" />
        <img
          src="{{ bookSelected.bookImage }}"
          alt="{{ bookSelected.bookTitle | translate }}"
          class="box__right--img"
          loading="lazy"
        />
      </picture>
    </div>
  </div>
</section>
